import { render, staticRenderFns } from "./invoicesList-sam.vue?vue&type=template&id=5fe92e64"
import script from "./invoicesList-sam.vue?vue&type=script&lang=js"
export * from "./invoicesList-sam.vue?vue&type=script&lang=js"
import style0 from "./invoicesList-sam.vue?vue&type=style&index=0&id=5fe92e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports